export default "__VITE_ASSET__BwKkjHN___"